export default __webpack_public_path__ + "static/media/decision-making.dbfddc21.svg";